const galleryTypes = [
    {id: 1, title: 'История'},
    {id: 2, title: 'Концерты'},
    {id: 3, title: 'Личные фотографии'},
    {id: 4, title: 'Разные события'},
]

export default galleryTypes;